import React from 'react';
import LoadingSpinner from '../../common/LoadingSpinner';
import ShippingRateOptions from '../delivery/components/ShippingRateOptions';

const ReturnShippingRates = ({
  shouldShowRatesSection,
  ratesError,
  isLoadingRates,
  formattedRates,
  selectedCustomerAddress,
  selectedRate,
  handleRateSelect
}) => {
  if (!shouldShowRatesSection) {
    return null;
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-medium mb-4">Return Shipping Options</h3>
      
      {ratesError ? (
        <div className="p-4 bg-red-50 border border-red-200 rounded mb-4">
          <p className="text-red-700 text-sm">{ratesError}</p>
          <div className="mt-2">
            <button
              onClick={() => window.location.reload()}
              className="text-sm text-brand-teal hover:text-brand-teal-dark"
            >
              Try Again
            </button>
          </div>
        </div>
      ) : isLoadingRates ? (
        <div className="flex flex-col items-center justify-center p-8 text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-gray-600">Calculating shipping rates...</p>
          <p className="mt-2 text-sm text-gray-500">This may take a few moments</p>
        </div>
      ) : formattedRates.length > 0 ? (
        <ShippingRateOptions
          sharedAddress={selectedCustomerAddress}
          loading={false}
          ratesLoading={isLoadingRates}
          shippingRates={formattedRates}
          selectedRate={selectedRate?.id}
          handleRateSelection={id => {
            const rate = formattedRates.find(r => r.id === id);
            if (rate) handleRateSelect(rate);
          }}
        />
      ) : (
        <div className="p-4 text-center text-gray-600">
          {formattedRates && formattedRates.length === 0 ? (
            <>
              <p>No shipping rates available for the selected addresses</p>
              <p className="text-sm mt-2">Please try a different shipping address or contact support.</p>
            </>
          ) : (
            <>
              <p>Shipping rates will appear after selecting your address</p>
              <p className="text-sm mt-2">Please select your address above to continue</p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ReturnShippingRates; 